import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Feature {
  id: string;
  text: string;
}

const TurnKeySolutionsSection = () => {
  const features: Feature[] = [
  { id: 'feature_built', text: 'Fully built out container (insulated, wired & plumbed)' },
  { id: 'feature_electrical', text: 'Electrical system: 100–250V / IP44 panel' },
  { id: 'feature_led', text: 'LED lighting throughout' },
  { id: 'feature_steel', text: 'Stainless steel counters' },
  { id: 'feature_doors', text: 'Doors & service windows' },
  { id: 'feature_ac', text: 'AC-ready' },
  { id: 'feature_equipment', text: 'Professional restaurant equipment (varies by business type)' }];


  return (
    <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="reveal">
            <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6 leading-tight">
              Turn-Key Containers <span className="text-primary">Built for Business</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Every container comes fully equipped and ready to operate. We handle the construction, you focus on your business.
            </p>

            {/* Features Checklist */}
            <div className="space-y-4">
              {features.map((feature) =>
              <div key={feature.id} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Icon name="CheckIcon" size={16} className="text-primary" />
                  </div>
                  <p className="text-foreground">{feature.text}</p>
                </div>
              )}
            </div>
          </div>

          {/* Right Image */}
          <div className="reveal relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1d3fd0974-1771890051709.png"
                alt="Interior of custom container showing stainless steel counters, LED lighting, and professional kitchen equipment"
                className="w-full h-[600px] object-cover" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default TurnKeySolutionsSection;